<template>
  <div class="grid-x grid-padding-x">
    <div class="cell small-5">
      <img 
        v-if="location.image_url" 
        :src="location.image_url" 
        class="rounded">
      <div style="margin-top:1rem">
        <a 
          v-if="coordinate"
          class="btn btn-white btn-small btn-expanded no-margin"
          @click.prevent="$emit('show-map', location)">
          <div class="grid-x align-middle" style="line-height:1">
            <div class="cell shrink">
              <span v-html="$icons.get('map', 'small black')" style="margin-right:.3rem"></span>
            </div>
            <div class="cell auto">
              View on map
            </div>
          </div>
        </a>
      </div>
    </div>
    <div class="cell small-7">
      <strong>{{ location.title }}</strong><br>
      {{ location.address }}<br>
      {{ location.city }}, {{ location.state }}<br>
      <span v-if="location.phone"><strong>{{ location.phone }}</strong></span>
      
    </div>
  </div>
</template>

<script>
export default {
  name: 'LocationCard',
  props: {
    location: {
      type: Object,
      required: true
    },
    map: {
      type: [Boolean, Object]
    }
  },
  computed: {
    coordinate () {
      if (this.location.lat && this.location.lng) {
        return [this.location.lat, this.location.lng]
      }
      return false
    }
  }
}
</script>
